<template>
  <div>
    <el-dialog
      :visible.sync="editHours"
      :before-close="cancelEdit"
      :title="hoursTitle"
      width="900px"
    >
      <div class="editHours">
        <el-table :data="workHorusData" height="500px">
          <el-table-column property="tt_id" label="ID" width="150"/>
          <el-table-column property="tt_coding_start_date" label="日期" width="150"/>
          <el-table-column property="tt_coding_time" label="工时" width="200"/>
          <el-table-column property="tt_note" label="备注"/>
          <el-table-column fixed="right" label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="editHoursData(scope.row)">编辑</el-button>
              <el-button type="text" size="small" @click="deleteHours(scope.row.tt_id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelEdit">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="hoursData" title="编辑工时表单">
      <el-form :model="hoursDataForm" size="small">
        <el-form-item :label-width="formLabelWidth" label="日期">
          <el-date-picker
            disabled
            v-model="hoursDataForm.tt_coding_start_date"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
            style="width:400px;"
          />
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="消耗工时">
          <el-input-number :max="12" :min="0.1" :step="0.1"
          @blur="changeHours" @input.native="inputHours"
            v-model.number="hoursDataForm.tt_coding_time"
            style="width:400px;"
          />
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="备注">
          <el-input v-model="hoursDataForm.tt_note" style="width:400px;"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="hoursData = false">取 消</el-button>
        <el-button type="primary" @click="submitHoursData" :loading="submitLoading">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { hoursList } from '@/api/allTask'
// import Tinymce from '@/components/Tinymce'
export default {
  name: 'editHours',
  props: ['visible', 'typesId'],
  // components: { Tinymce },
  data() {
    return {
      editHours: false,
      workHorusData: [],
      hoursData: false,
      hoursDataForm: {},
      hoursTitle: '',
      switchs: false,
      formLabelWidth: '120px',
      submitLoading: false,
    }
  },
  computed: {
    ...mapGetters(['userId', 'urlInfo'])
  },
  watch: {
    visible(val) {
      this.editHours = val
      this.editHoursList()
    }
  },
  created() {},
  methods: {
    cancelEdit() {
      this.$emit('cancelEdit')
      this.editHours = false
    },
    editHoursList() {
      if (this.typesId === 1) {
        this.hoursTitle = '编辑测试工时'
      }
      if (this.typesId === 0) {
        this.hoursTitle = '编辑开发工时'
      }

      hoursList(this.$route.query.task_id, this.typesId)
        .then(response => {
          // console.log(response.data);
          this.workHorusData = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    // 编辑工时
    editHoursData(rowdata) {
      this.hoursData = true
      const params = {
        task_id: rowdata.task_id,
        tt_id: rowdata.tt_id,
        tt_coding_start_date: rowdata.tt_coding_start_date,
        tt_coding_time: rowdata.tt_coding_time,
        tt_note: rowdata.tt_note,
        update_task_tims: 1,
        tt_type: this.typesId, // 0开发 1测试 必填
        user_id: this.userId
      }
      this.hoursDataForm = params
    },
    closeLoading() {
      this.submitLoading = false
    },
    submitHoursData(params) {
      this.submitLoading = true
      this.$emit('submitHoursData', this.hoursDataForm)
      this.editHoursList()
      this.hoursData = false
    },
    // 删除工时
    deleteHours(delParams) {
      const params = {
        delete_task_tims: 1,
        tt_id: delParams,
        user_id: this.userId
      }
      this.$confirm('此操作将删除该工时, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$emit('deleteHours', params)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    changeHours(val) {
      // 超过12 或者小于0，提示 一天工时不允许超过12小时
      if (this.inputHourValue > 12 || this.inputHourValue < 0) {
        this.$message({
          type: 'warning',
          message: '一天工时不允许超过12小时和小于1小时'
        })
      }
    },
    inputHours(val){
      this.inputHourValue = val.target.value
    }
  }
}
</script>
<style scope>
</style>
